!function() {
  "use strict";
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let r = [], a = false, n = null;
  const i = (e2) => Date.now() - e2 > 3e5, o = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: a2 }) => {
    try {
      const n2 = `https://${e2}/api/2024-07/graphql.json`, i2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, o2 = await fetch(n2, { method: "POST", headers: i2, body: JSON.stringify({ query: r2, variables: a2 }) });
      return await o2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, c = async (o2, c2, s2, u2, p2, d2) => {
    const y2 = ((e2, t2, r2, a2, n2) => `${e2}:${t2}:${r2}:${JSON.stringify(a2)}:${n2}`)(o2, s2, u2, p2, d2), m2 = e.get(y2);
    if (m2 && !i(m2.timestamp)) return m2.data;
    const g2 = t.get(y2);
    if (g2) return g2;
    const P = (f = { shopDomain: o2, accessToken: c2, handle: s2, customerGroupId: u2, customerTags: p2, clayCountryIsoCode: d2, cacheKey: y2 }, new Promise((e2, t2) => {
      r.push({ ...f, resolve: e2, reject: t2 }), a || (a = true, queueMicrotask(() => {
        a = false, function() {
          if (0 === r.length) return;
          const e3 = r;
          r = [];
          for (let t3 = 0; t3 < e3.length; t3 += 10) {
            const r2 = e3.slice(t3, t3 + 10), a2 = null === n, i2 = l(r2, a2);
            a2 && (n = i2);
          }
        }();
      }));
    }));
    var f;
    return t.set(y2, P), P.finally(() => {
      t.delete(y2);
    }), P;
  };
  async function l(t2, r2) {
    var _a, _b, _c;
    if (!r2 && n) try {
      await n;
    } catch {
    }
    const a2 = t2[0];
    try {
      const r3 = `query batchProductMetafield($country: CountryCode) @inContext(country: $country) {
    ${t2.map((e2) => e2.handle).map((e2, t3) => `p${t3}: product(handle: ${JSON.stringify(e2)}) {
      title
      handle
      variants(first: 50) {
        edges {
          node {
            id
            title
            metafield(namespace: "app--173437812737--clay", key: "pricing_rule") {
              value
              type
            }
            price { amount currencyCode }
            compareAtPrice { amount currencyCode }
            availableForSale
          }
        }
        pageInfo { hasNextPage endCursor }
      }
    }`).join("\n")}
  }`, n2 = await o({ shopDomain: a2.shopDomain, accessToken: a2.accessToken, query: r3, variables: { country: a2.clayCountryIsoCode } });
      if (!(n2 == null ? void 0 : n2.data)) {
        const e2 = new Error("Empty response from Storefront API");
        return void t2.forEach((t3) => t3.reject(e2));
      }
      for (let r4 = 0; r4 < t2.length; r4++) {
        const a3 = t2[r4], i2 = n2.data[`p${r4}`];
        if (!i2) {
          const t3 = { handle: a3.handle, allVariants: [] };
          e.set(a3.cacheKey, { data: t3, timestamp: Date.now() }), a3.resolve(t3);
          continue;
        }
        if ((_b = (_a = i2.variants) == null ? void 0 : _a.pageInfo) == null ? void 0 : _b.hasNextPage) {
          u(a3.shopDomain, a3.accessToken, a3.handle, a3.customerGroupId, a3.customerTags, a3.clayCountryIsoCode, a3.cacheKey).then((e2) => a3.resolve(e2)).catch(a3.reject);
          continue;
        }
        const o2 = (((_c = i2.variants) == null ? void 0 : _c.edges) || []).map((e2) => s(e2.node, a3.customerGroupId, a3.customerTags)), c2 = { handle: a3.handle, allVariants: o2 };
        e.set(a3.cacheKey, { data: c2, timestamp: Date.now() }), a3.resolve(c2);
      }
      p();
    } catch (e2) {
      console.error("Error in batched product metafield fetch:", e2), t2.forEach((t3) => t3.reject(e2));
    }
  }
  function s(e2, t2, r2) {
    var _a;
    const a2 = e2.id.split("/").pop(), n2 = (_a = e2.metafield) == null ? void 0 : _a.value, i2 = function(e3) {
      if (!Array.isArray(e3) || 0 === e3.length) return [];
      const t3 = e3[0];
      if ("customerGroupId" in t3) return r3 = e3, Array.isArray(r3) ? r3.map((e4 = {}) => {
        const { customerGroupId: t4 = "", customerTag: r4 = "", type: a3 = "WHOLESALE", wholesalePrice: n3 = null, quantityPrice: i3 = {} } = e4;
        let o3 = false;
        "QUANTITY" === a3 && (o3 = !!i3.isVariantUnique);
        let c3 = [];
        return "WHOLESALE" === a3 && null != n3 ? c3.push({ quantity: "1", price: n3 }) : Array.isArray(i3.value) && (c3 = i3.value), { ownerId: "", customerGroupId: t4, customerTag: r4, markets: [{ handle: "", currency: "", pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: o3, priceSource: "R", values: c3 } }] };
      }) : [];
      var r3;
      if ("i" in t3) return function(e4) {
        if (!e4 || !Array.isArray(e4)) return null;
        const t4 = e4.map((e5 = {}) => {
          let t5 = e5.o || "", [r4 = "", a3 = ""] = (e5.i || "").split("~");
          return { ownerId: t5, customerGroupId: r4, customerTag: a3, markets: e5.p.split("|").map((e6) => {
            let [t6 = "", r5 = "", a4 = "A", n3 = "0", i3 = "R", o3 = ""] = e6.split("~"), c3 = o3.split(";").map((e7) => {
              let [t7 = "1", r6 = "0"] = e7.split(":");
              return { quantity: t7, price: r6 };
            }) ?? [];
            return { handle: t6, currency: r5, pricing: { type: c3.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: a4, priceSource: i3, isVariantUnique: "1" === n3, values: c3 } };
          }) };
        });
        return t4;
      }(e3);
      return [];
    }("string" == typeof n2 ? JSON.parse(n2) : []);
    let o2 = i2.find((e3) => e3.customerGroupId === t2 && !["LOGGED_IN", "ALL"].includes(t2) || r2.includes(e3.customerTag));
    o2 || "ALL" === t2 || (o2 = i2.find((e3) => "LOGGED_IN" === e3.customerGroupId)), o2 || (o2 = i2.find((e3) => "ALL" === e3.customerGroupId));
    const c2 = window.clayMarketHandle;
    if (o2) {
      const t3 = o2.markets.find((e3) => e3.handle === c2 || "" === e3.handle) || null;
      if (t3) {
        const r3 = { ...o2, markets: [t3] };
        if ("" === r3.ownerId || r3.ownerId === a2.split("/").pop()) return { id: a2, title: e2.title, pricingRule: r3, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
      }
    }
    return { id: a2, title: e2.title, pricingRule: null, price: e2.price, compareAtPrice: e2.compareAtPrice, availableForSale: e2.availableForSale };
  }
  async function u(t2, r2, a2, n2, i2, c2, l2) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    try {
      let u2, d2 = true;
      const y2 = [];
      for (; d2; ) {
        const p2 = await o({ shopDomain: t2, accessToken: r2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250, after: ${u2 ? `"${u2}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                    availableForSale
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: a2, country: c2 } });
        if (!((_a = p2.data) == null ? void 0 : _a.product)) {
          const t3 = { handle: a2, allVariants: [] };
          return e.set(l2, { data: t3, timestamp: Date.now() }), t3;
        }
        const m3 = (((_b = p2.data.product.variants) == null ? void 0 : _b.edges) || []).map((e2) => s(e2.node, n2, i2));
        y2.push(...m3), d2 = (_f = (_e = (_d = (_c = p2.data) == null ? void 0 : _c.product) == null ? void 0 : _d.variants) == null ? void 0 : _e.pageInfo) == null ? void 0 : _f.hasNextPage, u2 = (_j = (_i = (_h = (_g = p2.data) == null ? void 0 : _g.product) == null ? void 0 : _h.variants) == null ? void 0 : _i.pageInfo) == null ? void 0 : _j.endCursor;
      }
      const m2 = { handle: a2, allVariants: y2 };
      return e.set(l2, { data: m2, timestamp: Date.now() }), p(), m2;
    } catch (e2) {
      throw console.error("Error fetching product metafield:", e2), e2;
    }
  }
  const p = () => {
    for (const [t2, r2] of e.entries()) i(r2.timestamp) && e.delete(t2);
  };
  function d(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, a2 = r2.toFixed(2), n2 = r2.toFixed(0), i2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), o2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = a2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), s2 = a2.replace(".", ","), u2 = i2.replace(/(\d+)\.(\d{2})$/, "$1,$2"), p2 = c2.replace(/(\d+)\.(\d{2})$/, "$1,$2");
    return t2.replace("{{amount}}", a2).replace("{{amount_no_decimals}}", n2).replace("{{amount_with_comma_separator}}", i2).replace("{{amount_no_decimals_with_comma_separator}}", o2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", l2).replace("{{amount_with_comma_decimal}}", s2).replace("{{amount_with_comma_separator_and_comma_decimal}}", u2).replace("{{amount_with_period_separator_and_comma_decimal}}", p2);
  }
  function y(e2, t2, r2) {
    var _a;
    let a2 = "", n2 = "", i2 = "", o2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let l2 = c2.pricing.type;
    return "QUANTITY" === l2 ? { retailPriceText: a2, compareAtPriceText: n2, savingsText: i2, maxRetailPriceText: o2 } = function(e3, t3, r3, a3) {
      let n3 = a3.pricing.strategy, i3 = a3.pricing.values, o3 = a3.currency, c3 = e3.price.currencyCode, l3 = "R" === a3.pricing.priceSource ? e3.price.amount : "C" === a3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s2 = window.marketConversionRate;
      if (!l3 || "" === l3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let u2 = i3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (o3 !== c3 && "" !== o3) {
        if (!s2 || !s2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (u2 = (parseFloat(u2) * s2.conversion_rate).toFixed(2).toString());
      }
      let p2 = "A" === n3 ? u2 : "P" === n3 ? (parseFloat(l3) * (1 - parseFloat(u2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(l3) - parseFloat(u2)).toFixed(2).toString() : e3.price.amount;
      if ("" === o3 && s2 && s2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p2) < 0 || parseFloat(p2) > parseFloat(e3.price.amount)) && (p2 = e3.price.amount);
      let y2 = d(p2, clayProductPriceConfig.priceDisplayText), m2 = d(l3, clayProductPriceConfig.compareAtPriceDisplayText), g2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(l3) - parseFloat(p2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(l3) - parseFloat(p2)) / parseFloat(l3) * 100).toFixed(2) : 0, P = d(g2, clayProductPriceConfig.savingsDisplayText);
      return s2 && (y2 = window.clayCurrencySymbol + parseFloat(p2).toFixed(2) + " " + window.clayCountryCurrency, m2 = window.clayCurrencySymbol + parseFloat(l3).toFixed(2) + " " + window.clayCountryCurrency, P = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + g2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? g2 + "%" : "")), { retailPriceText: y2, compareAtPriceText: m2, savingsText: P, maxRetailPriceText: "" };
    }(e2, 0, r2, c2) : "WHOLESALE" === l2 && ({ retailPriceText: a2, compareAtPriceText: n2, savingsText: i2, maxRetailPriceText: o2 } = function(e3, t3, r3) {
      let a3 = r3.pricing.strategy;
      r3.pricing.values;
      let n3 = r3.currency, i3 = e3.price.currencyCode, o3 = window.marketConversionRate, c3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l3 = r3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (n3 !== i3 && "" !== n3) {
        if (!o3 || !o3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(a3) && (l3 = (parseFloat(l3) * o3.conversion_rate).toFixed(2).toString());
      }
      let s2 = "A" === a3 ? l3 : "P" === a3 ? (parseFloat(c3) * (1 - parseFloat(l3) / 100)).toFixed(2).toString() : "F" === a3 ? (parseFloat(c3) - parseFloat(l3)).toFixed(2).toString() : e3.price.amount;
      if ("" === n3 && o3 && o3.base_currency !== i3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(s2) < 0 || parseFloat(s2) > parseFloat(e3.price.amount)) && (s2 = e3.price.amount);
      let u2 = d(s2, clayProductPriceConfig.priceDisplayText), p2 = d(c3, clayProductPriceConfig.compareAtPriceDisplayText), y2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(s2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(s2)) / parseFloat(c3) * 100).toFixed(2) : 0, m2 = d(y2, clayProductPriceConfig.savingsDisplayText);
      return o3 && (u2 = window.clayCurrencySymbol + parseFloat(s2).toFixed(2) + " " + window.clayCountryCurrency, p2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, m2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + y2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? y2 + "%" : "")), { retailPriceText: u2, compareAtPriceText: p2, savingsText: m2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: a2, compareAtPriceText: n2, savingsText: i2, maxRetailPriceText: o2 };
  }
  async function m() {
    g({ productGrid: ".spf-product-card", productGridProductUrl: ".boost-kategorie-produkt-name a", productGridProductPrice: ".boost-kategorie-produkt-price", retailPriceBlockFormatOnCollectionsPage: "<span>{retailPriceText}</span>", comparePriceBlockFormatOnCollectionsPage: '<span>{retailPriceText} </span><span style="text-decoration: line-through;">{compareAtPriceText}</span>' }, 0, 1e4, 0);
  }
  function g(e2, t2, r2, a2) {
    let n2 = document.querySelectorAll(e2.productGrid);
    n2 = Array.from(n2).filter((t3) => {
      const r3 = t3.querySelector(e2.productGridProductPrice);
      return r3 && !r3.classList.contains("clay-wholesale-price");
    }), n2 && n2.length > 0 && n2.length !== a2 && function(e3, t3) {
      e3.forEach(async (e4, r3) => {
        let a3 = function(e5) {
          if (!e5 || "" === e5) return null;
          let t4 = null;
          const r4 = e5.match(/\/products\/([^/?#]+)/);
          return r4 && r4[1] && (t4 = decodeURIComponent(r4[1])), t4;
        }(e4.querySelector(t3.productGridProductUrl).href);
        const n3 = e4.querySelector(t3.productGridProductPrice);
        if (!n3 || n3.classList.contains("clay-wholesale-price")) return;
        const i2 = await async function(e5) {
          const t4 = window.clayStorefrontConfig || {}, r4 = window.clayCustomerTier || {}, a4 = window.clayCustomerTags || [], n4 = window.clayCountryIsoCode, { allVariants: i3 } = await c(t4.shopDomain, t4.token, e5, "" === r4.customerGroupId ? "LOGGED_IN" : r4.customerGroupId, a4, n4);
          return i3;
        }(a3);
        !async function(e5, t4, r4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const a4 = e5[0];
          if (!a4.pricingRule) return;
          const n4 = t4.querySelector(r4.productGridProductPrice), { retailPriceText: i3, compareAtPriceText: o2, savingsText: c2, maxRetailPriceText: l2 } = y(a4, 0, 1);
          if ("" === i3) return;
          const s2 = function(e6, t5, r5, a5) {
            if (t5.comparePriceBlockFormatOnCollectionsPage && r5 !== a5) return t5.comparePriceBlockFormatOnCollectionsPage;
            if (t5.comparePriceBlockFormatOnProductPage && r5 !== a5) return t5.comparePriceBlockFormatOnProductPage;
            return t5.retailPriceBlockFormatOnCollectionsPage || t5.retailPriceBlockFormatOnProductPage || "{retailPriceText}";
          }(0, r4, i3, o2);
          let u2 = function(e6, t5, r5, a5, n5) {
            return e6.replace("{retailPriceText}", t5).replace("{compareAtPriceText}", r5).replace("{savingsText}", a5).replace("{maxRetailPriceText}", n5);
          }(s2, i3, o2, c2, l2);
          n4.classList.contains("clay-wholesale-price") || (n4.innerHTML = u2, n4.classList.add("clay-wholesale-price"));
        }(i2, e4, t3);
      });
    }(n2, e2), t2 < r2 && setTimeout(() => {
      g(e2, t2 + 200, r2, n2.length);
    }, 200);
  }
  !function() {
    window.addEventListener("popstate", m);
    const e2 = history.pushState;
    history.pushState = function() {
      e2.apply(this, arguments), m();
    };
    const t2 = history.replaceState;
    history.replaceState = function() {
      t2.apply(this, arguments), m();
    }, m();
  }();
}();
